import { atom, useAtomValue, useSetAtom } from 'jotai';
import { useEffect } from 'react';

const pageTitleAtom = atom('');
const pageSubtitleAtom = atom('');

export const useGetPageSubtitle = () => useAtomValue(pageSubtitleAtom);

export const useGetPageTitle = () => useAtomValue(pageTitleAtom);

const useSetter = <T>(t: T, setter: (t: T) => void, unmountValue: () => T) => {
  useEffect(() => {
    setter(t);
    return () => {
      setter(unmountValue());
    };
  }, [setter, t, unmountValue]);
};

export const useSetPageSubtitle = (subtitle: string) => {
  const setValue = useSetAtom(pageSubtitleAtom);
  useSetter(subtitle, setValue, () => '');
};

export const useSetPageTitle = (title: string) => {
  const setValue = useSetAtom(pageTitleAtom);
  useSetter(title, setValue, () => '');
};
